export type BaseDates = {
	  [dateMillis: number]: string;
}


export class TripModel {
	  tripKey: string;
	  createdAt: number;
	  tripTo: string;
	  tripNote: string;
	  tripDates: BaseDates;
	  expenditureKey: string;
	  itineraryKey: string;
	  isEditable = true; /* TRIP BECOMES UNEDITABLE WHEN ONE PLACE OF IT IS SET AS FULFILLED */
	  isCompleted = false;
	  isArchived = false;
	  
	  
	  constructor(tripKey: string, createdAt: number, tripTo: string, tripNote: string, tripDates: BaseDates | undefined, expenditureKey?: string, itineraryKey?: string) {
			 this.tripKey = tripKey;
			 this.createdAt = createdAt;
			 this.tripTo = tripTo;
			 this.tripNote = tripNote;
			 this.tripDates = tripDates || {};
			 this.expenditureKey = expenditureKey || tripKey;
			 this.itineraryKey = itineraryKey || tripKey;
	  }
	  
	  
	  static fromObject(obj: any): TripModel {
			 const {tripKey, createdAt, tripTo, tripNote, tripDates, expenditureKey, itineraryKey, isEditable, isCompleted, isArchived} = obj;
			 const trip = new TripModel(tripKey, createdAt, tripTo, tripNote, tripDates, expenditureKey, itineraryKey);
			 trip.isEditable = isEditable;
			 trip.isCompleted = isCompleted;
			 trip.isArchived = isArchived;
			 return trip;
	  }
	  
	  
	  getCreatedAtDate(): Date {
			 return new Date(this.createdAt);
	  }
	  
	  
	  getStartDate(): Date | null {
			 if (/*TRUTHY->*/ !!this.tripDates) {
					const keys = Object.keys(this.tripDates);
					if (keys.length > 0) {
						  return new Date(Number(keys[0]) /* KEY IS DATE MILLIS */);
					}
			 }
			 return null;
	  }
	  
	  
	  getEndDate(): Date | null {
			 if (/*TRUTHY->*/ !!this.tripDates) {
					const keys = Object.keys(this.tripDates);
					if (keys.length > 1) {
						  return new Date(Number(keys[keys.length - 1]) /* KEY IS DATE MILLIS */);
					}
			 }
			 return null;
	  }
	  
	  
	  setAsUneditable(): boolean {
			 this.isEditable = false;
			 return true;
	  }
	  
	  
	  setAsCompleted(): void {
			 this.setAsUneditable();
			 this.isCompleted = true;
	  }
	  
	  
	  setAsArchived(): void {
			 this.setAsCompleted();
			 this.isArchived = true;
	  }
}


export type ClosedOnDays = {
	  [dayOfWeek: string]: boolean;
}


export class PlaceModel {
	  placeKey: string;
	  name: string;
	  note: string;
	  isEatery: boolean;
	  isVeg: boolean;
	  isShop: boolean;
	  isPhotographyAllowed: boolean;
	  closedOnDays: ClosedOnDays;
	  anchoredOnDate: number;
	  isFulfilled = false;
	  
	  isTransport = false;	/* TRANSPORT FIELD */
	  transportName = "";	/* TRANSPORT FIELD */
	  
	  
	  constructor(placeKey: string, name: string, note: string,
					  isEatery: boolean, isVeg: boolean, isShop: boolean, isPhotographyAllowed: boolean,
					  closedOnDays: ClosedOnDays, anchoredOnDate: number,
					  isTransport?: boolean, transportName?: string) {
			 this.placeKey = placeKey;
			 this.name = name;
			 this.note = note;
			 this.isEatery = isEatery;
			 this.isVeg = isVeg;
			 this.isShop = isShop;
			 this.isPhotographyAllowed = isPhotographyAllowed;
			 this.closedOnDays = closedOnDays;
			 this.anchoredOnDate = anchoredOnDate;
			 
			 if (isTransport) {
					if (transportName) {
						  this.isTransport = true;
						  this.transportName = transportName;
					} else {
						  throw new Error("Transport place must have 'transportName' parameter");
					}
			 }
	  }
	  
	  
	  static fromObject(obj: any): PlaceModel {
			 const {placeKey, name, note, isEatery, isVeg, isShop, isPhotographyAllowed, closedOnDays, anchoredOnDate, isFulfilled, isTransport, transportName} = obj;
			 const place = new PlaceModel(placeKey, name, note, isEatery, isVeg, isShop, isPhotographyAllowed, closedOnDays, anchoredOnDate, isTransport, transportName);
			 place.isFulfilled = isFulfilled;
			 return place;
	  }
	  
	  
	  static asTransport(placeKey: string, name: string, transportName: string, note: string, anchoredOnDate: number): PlaceModel {
			 return new PlaceModel(placeKey, name, note, false, false, false, true, {}, anchoredOnDate, true, transportName);
	  }
	  
	  
	  static asPlace(placeKey: string, name: string, note: string, isEatery: boolean, isVeg: boolean, isShop: boolean, isPhotographyAllowed: boolean, closedOnDays: ClosedOnDays, anchoredOnDate: number): PlaceModel {
			 return new PlaceModel(placeKey, name, note, isEatery, isVeg, isShop, isPhotographyAllowed, closedOnDays, anchoredOnDate);
	  }
	  
	  
	  setAnchoredOnDate(anchoredOnDate: number): void {
			 this.anchoredOnDate = anchoredOnDate;
	  }
	  
	  
	  setAsFulfilled(): void {
			 if (this.isFulfilled) return;
			 this.isFulfilled = true;
	  }
	  
	  
	  reset(): void {
			 this.anchoredOnDate = null;
			 this.isFulfilled = false;
	  }
}


export type BasePlaces = {
	  [placeKey: string]: PlaceModel;
}


export type PlannedPlaces = {
	  [dateKey: string]: BasePlaces;
}


export class ItineraryModel {
	  itineraryKey: string;
	  unassignedPlaces: BasePlaces;
	  plannedPlaces: PlannedPlaces;
	  
	  
	  constructor(itineraryKey: string, unassignedPlaces: BasePlaces, plannedPlaces: PlannedPlaces) {
			 this.itineraryKey = itineraryKey;
			 this.unassignedPlaces = unassignedPlaces;
			 this.plannedPlaces = plannedPlaces;
	  }
	  
	  
	  static fromObject(obj: any): ItineraryModel {
			 const {itineraryKey, unassignedPlaces, plannedPlaces} = obj;
			 const itinerary = new ItineraryModel(itineraryKey, unassignedPlaces, plannedPlaces);
			 return itinerary;
	  }
}


export class PayerModel {
	  payerKey: string;
	  name: string;
	  payingFor: number;
	  paid = 0;
	  due = 0;
	  isFrozen = false;
	  
	  
	  constructor(payerKey: string, name: string, payingFor: number) {
			 this.payerKey = payerKey;
			 this.name = name;
			 this.payingFor = payingFor;
	  }
	  
	  
	  static fromObject(obj: any): PayerModel {
			 const {payerKey, name, payingFor, paid, due, isFrozen} = obj;
			 const payer = new PayerModel(payerKey, name, payingFor);
			 payer.paid = paid;
			 payer.due = due;
			 payer.isFrozen = isFrozen;
			 return payer;
	  }
	  
	  
	  setName(name: string): void {
			 if (this.isFrozen) return;
			 this.name = name;
	  }
	  
	  
	  setPayingFor(payingFor: number): void {
			 if (this.isFrozen) return;
			 this.payingFor = payingFor;
	  }
	  
	  
	  setPaid(paid: number): void {
			 if (this.isFrozen) return;
			 this.paid = paid;
	  }
	  
	  
	  setDue(due: number): void {
			 if (this.isFrozen) return;
			 this.due = due;
	  }
	  
	  
	  isFreezable(): boolean {
			 return (this.due === 0 && /*NOT->*/ !this.isFrozen);
	  }
	  
	  
	  freeze(): void {
			 this.isFrozen = true;
			 this.payingFor = 0;
	  }
}


export class ExpenseModel {
	  expenseKey = Date.now().toString();
	  paidByWhom: string;
	  paidHowMuch: number;
	  paidOn: number;
	  paidForWhat: string;
	  isReimbursement: boolean;
	  
	  
	  constructor(paidByWhom: string, paidHowMuch: number, paidOn: number, paidForWhat: string, isReimbursement: boolean) {
			 this.paidByWhom = paidByWhom;
			 this.paidHowMuch = paidHowMuch;
			 this.paidOn = paidOn;
			 this.paidForWhat = paidForWhat;
			 this.isReimbursement = isReimbursement;
	  }
	  
	  
	  static fromObject(obj: any): ExpenseModel {
			 const {expenseKey, paidByWhom, paidHowMuch, paidOn, paidForWhat, isReimbursement} = obj;
			 const expense = new ExpenseModel(paidByWhom, paidHowMuch, paidOn, paidForWhat, isReimbursement);
			 expense.expenseKey = expenseKey;
			 return expense;
	  }
}


export type BasePayers = {
	  [payerKey: string]: PayerModel;
}


export type BaseExpenses = {
	  [expenseKey: string]: ExpenseModel;
}


export class ExpenditureModel {
	  expenditureKey: string;
	  payers: BasePayers;
	  expenses: BaseExpenses;
	  
	  
	  constructor(expenditureKey: string, payers: BasePayers, expenses: BaseExpenses) {
			 this.expenditureKey = expenditureKey;
			 this.payers = payers;
			 this.expenses = expenses;
	  }
	  
	  
	  static fromObject(obj: any): ExpenditureModel {
			 const {expenditureKey, payers, expenses} = obj;
			 const expenditure = new ExpenditureModel(expenditureKey, payers, expenses);
			 return expenditure;
	  }
	  
	  
	  getTotalPersons(): number {
			 let persons = 0;
			 if (/*TRUTHY->*/ !!this.payers) {
					Object.values(this.payers).forEach((payer: PayerModel) => {
						  persons += payer.payingFor;
					});
			 }
			 return persons;
	  }
	  
	  
	  getTotalExpense(): number {
			 let totalExpense = 0;
			 if (/*TRUTHY->*/ !!this.expenses) {
					Object.values(this.expenses).forEach((expense: ExpenseModel) => {
						  if (/*NOT->*/ !expense.isReimbursement) totalExpense += expense.paidHowMuch;
					});
			 }
			 return totalExpense;
	  }
	  
}




export class EstimationModel {
	  estimationKey : string;
	  destination: string;
	  persons: number;
	  nights: number;
	  primaryFarePP: number;
	  secondaryFarePP: number;
	  roomCostPPPN: number;
	  foodCostPPPD: number;
	  sightseeing: number;
	  shopping: number;
	  extras: number;
	  total: number;
	  perHead: number;
	  
	  
	  constructor(destination: string, persons: number, nights: number, primaryFarePP: number, secondaryFarePP: number, roomCostPPPN: number, foodCostPPPD: number, sightseeing: number, shopping: number, extras: number, total: number, perHead: number) {
			 this.destination = destination;
			 this.persons = persons;
			 this.nights = nights;
			 this.primaryFarePP = primaryFarePP;
			 this.secondaryFarePP = secondaryFarePP;
			 this.roomCostPPPN = roomCostPPPN;
			 this.foodCostPPPD = foodCostPPPD;
			 this.sightseeing = sightseeing;
			 this.shopping = shopping;
			 this.extras = extras;
			 this.total = total;
			 this.perHead = perHead;
	  }
	  
	  static fromObject(obj: any): EstimationModel {
			 const {estimationKey, destination, persons, nights, primaryFarePP, secondaryFarePP, roomCostPPPN, foodCostPPPD, sightseeing, shopping, extras, total, perHead} = obj;
			 const estimation = new EstimationModel(destination, persons, nights, primaryFarePP, secondaryFarePP, roomCostPPPN, foodCostPPPD, sightseeing, shopping, extras, total, perHead);
			 estimation.estimationKey = estimationKey;
			 return estimation;
	  }
}